import { useForceInitGuard, useTenantHashGuard, useScrollReset } from './guards';

/**
 * Composition hook — single entry point for all app-level side effects.
 * Each guard is independently defined in `./guards/` and can be
 * tested, reordered, or extended without touching this file.
 *
 * To add a new guard: create a hook in `./guards/`, export from
 * the barrel, and add one line here.
 */
export function useAppShellGuards() {
  useForceInitGuard();
  useTenantHashGuard();
  useScrollReset();
}
